import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { configurationDealIdResolverRoutes } from './configuration-dealId-resolver.routes'
import { ProductConfigurationIdResolver } from './resolvers/productConfigurationId.resolver'

@NgModule({
    imports: [RouterModule.forChild(configurationDealIdResolverRoutes)],
    providers: [ProductConfigurationIdResolver],
})
export class ConfigurationDealIdResolverModule {}
